import React from "react";

interface PaginationProps {
  currentPage: number;
  totalItems: number;
  itemsPerPage: number;
  onPageChange: (page: number) => void;
  labelOnPage?: number;
}

const CustomPagination: React.FC<PaginationProps> = ({
                                                       currentPage,
                                                       totalItems,
                                                       itemsPerPage,
                                                       onPageChange,
                                                       labelOnPage
                                                     }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  if (totalPages <= 1) return null;

  const maxVisiblePages = 3;
  const pages: (number | string)[] = [];

  if (totalPages <= maxVisiblePages) {
    pages.push(...Array.from({ length: totalPages }, (_, i) => i + 1));
  } else {
    pages.push(1);

    if (currentPage > maxVisiblePages) {
      pages.push("...");
    }

    // Основные номера страниц
    const start = Math.max(2, currentPage - 2);
    const end = Math.min(totalPages - 1, currentPage + 2);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    if (currentPage < totalPages - maxVisiblePages + 1) {
      pages.push("...");
    }

    pages.push(totalPages);
  }

  return (
    <div className="flex flex-col items-center mt-6 space-y-2">
      <span className="text-lg font-semibold">Всего на странице: {labelOnPage}</span>
      <div className="flex space-x-2">
        <button
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage === 1}
          className={`px-2 py-1 text-lg font-semibold rounded-lg transition ${
            currentPage === 1
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-[#fec887] hover:bg-[#e0b478] text-black"
          }`}
        >
          Назад
        </button>

        {pages.map((page, index) =>
          typeof page === "number" ? (
            <button
              key={index}
              onClick={() => onPageChange(page)}
              className={`px-3 py-1 text-lg font-semibold rounded-lg transition ${
                page === currentPage
                  ? "bg-[#e0b478] text-black"
                  : "bg-[#fec887] hover:bg-[#e0b478]"
              }`}
            >
              {page}
            </button>
          ) : (
            <span key={index} className="px-3 py-1 text-lg font-semibold">
                            ...
                        </span>
          )
        )}

        <button
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage === totalPages}
          className={`px-2 py-1 text-lg font-semibold rounded-lg transition ${
            currentPage === totalPages
              ? "bg-gray-300 text-gray-500 cursor-not-allowed"
              : "bg-[#fec887] hover:bg-[#e0b478] text-black"
          }`}
        >
          Вперед
        </button>
      </div>
    </div>
  );
};

export default CustomPagination;
